"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkFieldLogic = void 0;
var link_fieldtype_1 = require("./link.fieldtype");
Object.defineProperty(exports, "LinkFieldLogic", { enumerable: true, get: function () { return link_fieldtype_1.LinkFieldLogic; } });
